var map = {
	"./amex.png": "4b31",
	"./elo.png": "26a8",
	"./hipercard.png": "1e82",
	"./mastercard.png": "7e5a",
	"./mercadopago-hands.png": "86f5",
	"./no-image.png": "bd21",
	"./noimageavailable.png": "5a90",
	"./visa.png": "4b12",
	"./whatsapp-btn.png": "f544",
	"./zapermenu-dark.png": "2712",
	"./zapermenu-light.png": "68ea",
	"./zapermenu-min1.png": "7ffd",
	"./zapermenu.png": "0cdf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";